/**
 * Index hydrate — legacy safety only.
 * Both PC and mobile home tracks are SSR HTML now (no <template> for LCP).
 * Keeps hydrating any leftover template[data-m-only] in theme editor / old cache.
 */
(function () {
  var MQ_PC = '(min-width: 750px)';

  function isDesign() {
    return !!(window.Shopify && Shopify.designMode);
  }

  function isPcViewport() {
    try {
      return !!(window.matchMedia && window.matchMedia(MQ_PC).matches);
    } catch (e) {
      return false;
    }
  }

  function reviveScripts(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('script').forEach(function (old) {
      var s = document.createElement('script');
      Array.prototype.forEach.call(old.attributes || [], function (attr) {
        s.setAttribute(attr.name, attr.value);
      });
      if (!old.src) s.textContent = old.textContent;
      if (old.parentNode) old.parentNode.replaceChild(s, old);
    });
  }

  function hydrateMobileHome() {
    if (isPcViewport() && !isDesign()) return;
    document.querySelectorAll('template[data-m-only]:not([data-hydrated])').forEach(function (tpl) {
      tpl.setAttribute('data-hydrated', '1');
      var holder = document.createElement('div');
      holder.appendChild(tpl.content.cloneNode(true));
      var nodes = [];
      while (holder.firstChild) {
        var n = holder.firstChild;
        tpl.parentNode.insertBefore(n, tpl);
        nodes.push(n);
      }
      nodes.forEach(function (n) {
        if (n.nodeType === 1) reviveScripts(n);
      });
    });
  }

  function hydrate() {
    window.__INDEX_IS_PC = isPcViewport();
    hydrateMobileHome();
    try {
      document.dispatchEvent(new CustomEvent('index-track-hydrated'));
    } catch (e) {}
    return true;
  }

  window.__indexPcHydrate = hydrate;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrate);
  } else {
    hydrate();
  }

  try {
    window.matchMedia(MQ_PC).addEventListener('change', function () {
      window.__INDEX_IS_PC = isPcViewport();
      hydrateMobileHome();
    });
  } catch (e) {}
})();
